import { createFileRoute } from "@tanstack/react-router";
import {
	BRAND_NAME,
	COMPANY_ADDRESS,
	COMPANY_NAME,
} from "@/lib/constants/brand";

export const Route = createFileRoute("/privacy")({
	component: PrivacyPage,
});

function PrivacyPage() {
	return (
		<main className="mx-auto max-w-3xl px-6 py-16 text-sm text-muted-foreground">
			<h1 className="mb-2 text-2xl font-semibold text-foreground">
				Privacy Policy
			</h1>
			<p className="mb-8 text-xs">Last updated: 8 June 2026</p>

			<section className="mb-8 flex flex-col gap-3">
				<h2 className="text-base font-medium text-foreground">
					1. Data controller
				</h2>
				<p>
					{COMPANY_NAME}, {COMPANY_ADDRESS} ("we", "us") operates {BRAND_NAME}.
					For data-related enquiries contact our Data Protection Officer at{" "}
					<a
						href="mailto:dpo@slappos.com"
						className="font-medium text-foreground underline underline-offset-2"
					>
						dpo@slappos.com
					</a>
					.
				</p>
			</section>

			<section className="mb-8 flex flex-col gap-3">
				<h2 className="text-base font-medium text-foreground">
					2. Data we collect
				</h2>
				<ul className="list-disc space-y-1 pl-5">
					<li>
						Account data — name, email, business details, and WorkOS
						authentication identifiers.
					</li>
					<li>
						Operational data — sales, customers, inventory, staff records, and
						branch configuration entered by your organisation.
					</li>
					<li>
						Sensitive health data (PDPA §26) — prescription records, cannabis
						dispensing records, and health notes entered during pharmacy
						operations (only where you have granted explicit consent or where
						statutory reporting applies).
					</li>
				</ul>
			</section>

			<section className="mb-8 flex flex-col gap-3">
				<h2 className="text-base font-medium text-foreground">3. Purpose</h2>
				<p>
					Data is processed solely to operate the {BRAND_NAME} point-of-sale
					service, fulfil legally required reporting obligations, and provide
					support. It is never sold or shared with third parties except as
					required by Thai law (e.g. FDA cannabis reporting under applicable
					regulations).
				</p>
			</section>

			<section className="mb-8 flex flex-col gap-3">
				<h2 className="text-base font-medium text-foreground">4. Retention</h2>
				<ul className="list-disc space-y-1 pl-5">
					<li>
						Prescription and dispensing records — 5 years per applicable
						pharmaceutical regulations.
					</li>
					<li>
						Financial and tax records — as required by Thai accounting and
						revenue law.
					</li>
					<li>
						Other personal data — duration of your account, then deleted within
						90 days of account closure.
					</li>
				</ul>
			</section>

			<section className="mb-8 flex flex-col gap-3">
				<h2 className="text-base font-medium text-foreground">
					5. Your rights
				</h2>
				<p>
					Under Thai PDPA you have the right to access, correct, delete,
					restrict, port, and object to processing of your personal data. To
					exercise any right or withdraw consent, contact{" "}
					<a
						href="mailto:dpo@slappos.com"
						className="font-medium text-foreground underline underline-offset-2"
					>
						dpo@slappos.com
					</a>
					. Withdrawal of consent does not affect lawfulness of processing
					before withdrawal, and does not cover data processed under a statutory
					obligation.
				</p>
			</section>

			<section className="flex flex-col gap-3">
				<h2 className="text-base font-medium text-foreground">6. Changes</h2>
				<p>
					We will notify you of material changes via email or in-app notice
					before they take effect. Continued use after the effective date
					constitutes acceptance.
				</p>
			</section>
		</main>
	);
}
